import { render, staticRenderFns } from "./UserTemplate.vue?vue&type=template&id=45711038&scoped=true"
import script from "./UserTemplate.vue?vue&type=script&lang=js"
export * from "./UserTemplate.vue?vue&type=script&lang=js"
import style0 from "./UserTemplate.vue?vue&type=style&index=0&id=45711038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45711038",
  null
  
)

export default component.exports